module.exports = __webpack_public_path__ + "img/dc_logo.1f3c61f5.svg";